export default __webpack_public_path__ + "c3cfa138eb05184f795f879fcffe4674.webp";